import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/common/copy.png'


const _hoisted_1 = { class: "deposit_page" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "instructions" }
const _hoisted_4 = { class: "success_text" }
const _hoisted_5 = { class: "amount" }
const _hoisted_6 = { class: "qr_container" }
const _hoisted_7 = {
  key: 0,
  class: "loader_container"
}
const _hoisted_8 = ["src"]

import { ref, watch } from 'vue'
import CustomHeader from '../../components/common/customHeader.vue'
import { showToast } from 'vant';

export default /*@__PURE__*/_defineComponent({
  __name: 'QRPage',
  props: {
  show: Boolean,
  iframeUrl: String,
  selectedAmountVal : Number
},
  emits: ['close','goTo'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(true)

const iframeLoaded = () => {
  loading.value = false
}

watch(() => props.iframeUrl, () => {
  loading.value = true
})
const close = () => {
  emit('close')
}

const goToFundEmit = () => {
  emit('goTo')
}

const copyAmount = async () => {
  try {
    await navigator.clipboard.writeText(String(props.selectedAmountVal))
    showToast('Cópia Bem-sucedida');
  } catch (err) {
    console.error('Failed to copy: ', err)
  }
}



return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('common.deposite'),
      isPopupCloseBackIcon: true,
      "show-fund": true,
      "is-finalizar": true,
      onClosePopup: close,
      onGoToFund: goToFundEmit
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('deposit.qrInstruction1')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('deposit.qrInstruction2')), 1),
        _createElementVNode("li", _hoisted_4, _toDisplayString(_ctx.$t('deposit.qrInstruction3')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, "R$ " + _toDisplayString(__props.selectedAmountVal), 1),
        _createElementVNode("img", {
          src: _imports_0,
          class: "copy_icon",
          onClick: copyAmount
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_van_loading, {
                type: "spinner",
                size: "30px"
              })
            ]))
          : _createCommentVNode("", true),
        (__props.iframeUrl)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 1,
              src: __props.iframeUrl,
              frameborder: "0",
              onLoad: iframeLoaded
            }, null, 40, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})